<template>
  <svg :width="resolvedSize" :height="resolvedSize" id="icon_workspace_premium" xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20" fill="none">
    <title>Workspace premium</title>
    <path
      d="M8.06634 10.9917L9.99967 9.525L11.9247 10.9917L11.1913 8.61667L13.1247 7.08333H10.758L9.99967 4.74167L9.24134 7.08333H6.87467L8.79967 8.61667L8.06634 10.9917ZM16.6663 7.91667C16.6663 4.23333 13.683 1.25 9.99967 1.25C6.31634 1.25 3.33301 4.23333 3.33301 7.91667C3.33301 9.60833 3.96634 11.1417 4.99967 12.3167V18.75L9.99967 17.0833L14.9997 18.75V12.3167C16.033 11.1417 16.6663 9.60833 16.6663 7.91667ZM9.99967 2.91667C12.758 2.91667 14.9997 5.15833 14.9997 7.91667C14.9997 10.675 12.758 12.9167 9.99967 12.9167C7.24134 12.9167 4.99967 10.675 4.99967 7.91667C4.99967 5.15833 7.24134 2.91667 9.99967 2.91667ZM9.99967 15.4167L6.66634 16.2667V13.6833C7.64967 14.25 8.78301 14.5833 9.99967 14.5833C11.2163 14.5833 12.3497 14.25 13.333 13.6833V16.2667L9.99967 15.4167Z"
      :fill="resolvedFill" />
  </svg>
</template>

<script>
export default {
  props: {
    color: { type: String, default: null },
    size: { type: [String, Number], default: "20px" },
  },
  computed: {
    resolvedFill() {
      if (!this.color) return "currentColor";
      const themeName = this.$store.state.theme;
      const themes = this.$vuetify.theme.themes;
      const fromTheme =
        themes[themeName]?.[this.color] ?? themes.light?.[this.color];
      if (fromTheme) return fromTheme;
      return this.getColor(this.color);
    },
    resolvedSize() {
      if (this.size == null || this.size === "") return "20px";
      if (typeof this.size === "number") return `${this.size}px`;
      return this.size;
    },
  },
};
</script>

<style>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -6px;
}
</style>